import { ClientClassification } from '@monorepo/functions/src/types/client'
import { HotelPricingConfig } from '@monorepo/functions/src/types/config'
import { Pet } from '@monorepo/functions/src/types/reservations'

const isRegularClient = (clientClassification?: ClientClassification) =>
    !clientClassification || clientClassification === 'normal'

const isOneSmallPetAndRegularClient = (pets: Pet[], clientClassification?: ClientClassification) => {
    return pets.length === 1 && pets[0].size === 'pequeño' && isRegularClient(clientClassification)
}

const isTwoSmallPetsAndRegularClient = (pets: Pet[], clientClassification?: ClientClassification) => {
    return pets.length === 2 && pets.every(pet => pet.size === 'pequeño') && isRegularClient(clientClassification)
}

const isThreeSmallPetsAndRegularClient = (pets: Pet[], clientClassification?: ClientClassification) => {
    return pets.length === 3 && pets.every(pet => pet.size === 'pequeño') && isRegularClient(clientClassification)
}

const isOneSmallPetAndVIPClient = (pets: Pet[], clientClassification?: ClientClassification) => {
    return pets.length === 1 && pets[0].size === 'pequeño' && clientClassification === 'VIP'
}

const isTwoSmallPetsAndVIPClient = (pets: Pet[], clientClassification?: ClientClassification) => {
    return pets.length === 2 && pets.every(pet => pet.size === 'pequeño') && clientClassification === 'VIP'
}

const isThreeSmallPetsAndVIPClient = (pets: Pet[], clientClassification?: ClientClassification) => {
    return pets.length === 3 && pets.every(pet => pet.size === 'pequeño') && clientClassification === 'VIP'
}

const isOneMediumPetAndRegularClient = (pets: Pet[], clientClassification?: ClientClassification) => {
    return pets.length === 1 && pets[0].size === 'mediano' && isRegularClient(clientClassification)
}

const isTwoMediumPetsAndRegularClient = (pets: Pet[], clientClassification?: ClientClassification) => {
    return pets.length === 2 && pets.every(pet => pet.size === 'mediano') && isRegularClient(clientClassification)
}

const isThreeMediumPetsAndRegularClient = (pets: Pet[], clientClassification?: ClientClassification) => {
    return pets.length === 3 && pets.every(pet => pet.size === 'mediano') && isRegularClient(clientClassification)
}

const isOneMediumPetAndVIPClient = (pets: Pet[], clientClassification?: ClientClassification) => {
    return pets.length === 1 && pets[0].size === 'mediano' && clientClassification === 'VIP'
}

const isTwoMediumPetsAndVIPClient = (pets: Pet[], clientClassification?: ClientClassification) => {
    return pets.length === 2 && pets.every(pet => pet.size === 'mediano') && clientClassification === 'VIP'
}

const isThreeMediumPetsAndVIPClient = (pets: Pet[], clientClassification?: ClientClassification) => {
    return pets.length === 3 && pets.every(pet => pet.size === 'mediano') && clientClassification === 'VIP'
}

const isOneBigPetAndRegularClient = (pets: Pet[], clientClassification?: ClientClassification) => {
    return pets.length === 1 && pets[0].size === 'grande' && isRegularClient(clientClassification)
}

const isTwoBigPetsAndRegularClient = (pets: Pet[], clientClassification?: ClientClassification) => {
    return pets.length === 2 && pets.every(pet => pet.size === 'grande') && isRegularClient(clientClassification)
}

const isThreeBigPetsAndRegularClient = (pets: Pet[], clientClassification?: ClientClassification) => {
    return pets.length === 3 && pets.every(pet => pet.size === 'grande') && isRegularClient(clientClassification)
}

const isOneBigPetAndVIPClient = (pets: Pet[], clientClassification?: ClientClassification) => {
    return pets.length === 1 && pets[0].size === 'grande' && clientClassification === 'VIP'
}

const isTwoBigPetsAndVIPClient = (pets: Pet[], clientClassification?: ClientClassification) => {
    return pets.length === 2 && pets.every(pet => pet.size === 'grande') && clientClassification === 'VIP'
}

const isThreeBigPetsAndVIPClient = (pets: Pet[], clientClassification?: ClientClassification) => {
    return pets.length === 3 && pets.every(pet => pet.size === 'grande') && clientClassification === 'VIP'
}

const isOneSmallOneMediumPet = (pets: Pet[]) => {
    return pets.length === 2 && pets.some(pet => pet.size === 'pequeño') && pets.some(pet => pet.size === 'mediano')
}

const isOneSmallOneBigPet = (pets: Pet[]) => {
    return pets.length === 2 && pets.some(pet => pet.size === 'pequeño') && pets.some(pet => pet.size === 'grande')
}

const isOneMediumOneBigPet = (pets: Pet[]) => {
    return pets.length === 2 && pets.some(pet => pet.size === 'mediano') && pets.some(pet => pet.size === 'grande')
}

export const getPetsPricing = (
    pets: Pet[],
    config: HotelPricingConfig,
    clientClassification?: ClientClassification,
) => {
    if (isOneSmallPetAndRegularClient(pets, clientClassification)) {
        return config.oneSmallPetAndRegularClientPrice
    }

    if (isTwoSmallPetsAndRegularClient(pets, clientClassification)) {
        return config.twoSmallPetsAndRegularClientPrice
    }

    if (isThreeSmallPetsAndRegularClient(pets, clientClassification)) {
        return config.threeSmallPetsAndRegularClientPrice
    }

    if (isOneSmallPetAndVIPClient(pets, clientClassification)) {
        return config.oneSmallPetAndVIPClientPrice
    }

    if (isTwoSmallPetsAndVIPClient(pets, clientClassification)) {
        return config.twoSmallPetsAndVIPClientPrice
    }

    if (isThreeSmallPetsAndVIPClient(pets, clientClassification)) {
        return config.threeSmallPetsAndVIPClientPrice
    }

    if (isOneMediumPetAndRegularClient(pets, clientClassification)) {
        return config.oneMediumPetAndRegularClientPrice
    }

    if (isTwoMediumPetsAndRegularClient(pets, clientClassification)) {
        return config.twoMediumPetsAndRegularClientPrice
    }

    if (isThreeMediumPetsAndRegularClient(pets, clientClassification)) {
        return config.threeMediumPetsAndRegularClientPrice
    }

    if (isOneMediumPetAndVIPClient(pets, clientClassification)) {
        return config.oneMediumPetAndVIPClientPrice
    }

    if (isTwoMediumPetsAndVIPClient(pets, clientClassification)) {
        return config.twoMediumPetsAndVIPClientPrice
    }

    if (isThreeMediumPetsAndVIPClient(pets, clientClassification)) {
        return config.threeMediumPetsAndVIPClientPrice
    }

    if (isOneBigPetAndRegularClient(pets, clientClassification)) {
        return config.oneBigPetAndRegularClientPrice
    }

    if (isTwoBigPetsAndRegularClient(pets, clientClassification)) {
        return config.twoBigPetsAndRegularClientPrice
    }

    if (isThreeBigPetsAndRegularClient(pets, clientClassification)) {
        return config.threeBigPetsAndRegularClientPrice
    }

    if (isOneBigPetAndVIPClient(pets, clientClassification)) {
        return config.oneBigPetAndVIPClientPrice
    }

    if (isTwoBigPetsAndVIPClient(pets, clientClassification)) {
        return config.twoBigPetsAndVIPClientPrice
    }

    if (isThreeBigPetsAndVIPClient(pets, clientClassification)) {
        return config.threeBigPetsAndVIPClientPrice
    }

    if (isOneSmallOneMediumPet(pets)) {
        return config.oneSmallOneMediumPetPrice
    }

    if (isOneSmallOneBigPet(pets)) {
        return config.oneSmallOneBigPetPrice
    }

    if (isOneMediumOneBigPet(pets)) {
        return config.oneMediumOneBigPetPrice
    }

    return 0
}
